import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { History, ThumbsUp, Clock, ListVideo, Play } from "lucide-react";
import api from "../../lib/api";
import MPlayShell, { fmtViews, timeAgo } from "./VidShared";

const TABS = [
  ["", "History", History], ["liked", "Liked videos", ThumbsUp], ["later", "Watch later", Clock], ["playlists", "Playlists", ListVideo],
];

export default function LibraryPage() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "";
  const [items, setItems] = useState([]);
  const [vids, setVids] = useState(null);

  useEffect(() => {
    const key = tab === "liked" ? "mp_liked" : tab === "later" ? "mp_later" : tab === "playlists" ? null : "mp_history";
    if (!key) { setItems([]); setVids([]); return; }
    try { setItems(JSON.parse(localStorage.getItem(key) || "[]")); } catch { setItems([]); }
  }, [tab]);

  useEffect(() => {
    if (items.length === 0) { setVids(tab === "playlists" ? [] : []); return; }
    Promise.all(items.slice(0, 30).map((s) => api.get(`/vid/by-slug/${encodeURIComponent(s)}`).then((r) => r.data).catch(() => null)))
      .then((rs) => setVids(rs.filter(Boolean)));
  }, [items, tab]);

  return (
    <MPlayShell>
      <div className="px-3 sm:px-6 pt-6 max-w-[1200px] mx-auto" data-testid="mplay-library">
        <h1 className="text-white font-extrabold text-2xl mb-5">Library</h1>
        <div className="flex gap-2 mb-6 overflow-x-auto mp-scroll">
          {TABS.map(([k, l, Icon]) => (
            <button key={k || "history"} onClick={() => setParams(k ? { tab: k } : {})} data-testid={`mp-lib-tab-${k || "history"}`}
              className={`mp-pill flex items-center gap-1.5 ${tab === k ? "on" : ""}`}><Icon className="h-3.5 w-3.5" />{l}</button>
          ))}
        </div>
        {tab === "playlists" ? (
          <div className="mp-panel rounded-2xl p-10 text-center" data-testid="mp-lib-playlists">
            <ListVideo className="h-10 w-10 text-emerald-400 mx-auto mb-3" />
            <p className="text-white font-extrabold">Playlists coming soon</p>
            <p className="text-white/50 text-sm mt-1">Save videos with “Save” on the watch page — they appear under Watch later.</p>
          </div>
        ) : !vids ? (
          <div className="py-16 flex justify-center"><div className="h-8 w-8 rounded-full border-2 border-white/10 border-t-emerald-400 animate-spin" /></div>
        ) : vids.length === 0 ? (
          <div className="mp-panel rounded-2xl p-10 text-center">
            <Play className="h-10 w-10 text-emerald-400 mx-auto mb-3" />
            <p className="text-white font-extrabold">Nothing here yet</p>
            <p className="text-white/50 text-sm mt-1">Videos you {tab === "liked" ? "like" : tab === "later" ? "save" : "watch"} will show up here.</p>
            <Link to="/videos" className="mp-green h-10 px-6 rounded-full text-sm font-extrabold inline-flex items-center mt-5" data-testid="mp-lib-browse">Browse videos</Link>
          </div>
        ) : (
          <div className="space-y-4">
            {vids.map((v) => (
              <Link key={v.id} to={`/v/${v.slug}`} className="flex gap-4 group" data-testid={`mp-lib-item-${v.id}`}>
                <div className="mp-thumb w-40 sm:w-56 aspect-video shrink-0">
                  {v.thumbnail_url ? <img src={v.thumbnail_url} alt="" className="h-full w-full object-cover" /> : <div className="h-full w-full bg-[#16221c]" />}
                </div>
                <div className="min-w-0 py-0.5">
                  <p className="text-white font-bold text-[15px] leading-snug line-clamp-2 group-hover:text-emerald-400 transition-colors">{v.title}</p>
                  <p className="text-white/50 text-[12.5px] mt-1.5">{v.creator_name}</p>
                  <p className="text-white/50 text-[12.5px]">{fmtViews(v.views)} views · {timeAgo(v.created_at)}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </MPlayShell>
  );
}
